import type { UseFetchOptions } from '#app'

export const useApi: typeof useFetch = function useApi<T>(url: string | (() => string), options?: UseFetchOptions<T>) {
  const { $api } = useNuxtApp()

  return useFetch(url, {
    ...options,
    $fetch: $api,
  })
}

export const useLazyApi: typeof useFetch = function <T>(
  url: string | (() => string),
  options?: Omit<UseFetchOptions<T>, 'lazy'>
) {
  return useApi(url, {
    ...options,
    lazy: true,
  })
}
